import { getDateObjectFromYYYYMMDDWithTimezoneAdjusted } from "@elixir/utils";
import { DatePicker } from "antd";
import dateFormat from "dateformat";
import moment from "dayjs";
import { ReactComponent as ChevronDownRegularIcon } from "../../../assets/icons/font-awesome/chevron-down-regular.svg";
import dayjs from "dayjs";

const CustomDatePicker = ({
  isToday = false,
  onChange,
  value,
}: {
  isToday?: boolean;
  value: moment.Dayjs;
  onChange: (value: any) => void;
}) => {
  return (
    <div
      id="date-selector"
      className="dr-w-175 dr-flex dr-items-center dr-h-36 dr-text-darwin-touch-primary-primary dr-overflow-hidden dr-rounded-8 "
    >
      <div
        className="w-30 dr-min-w-30 dr-h-full dr-flex dr-items-center dr-justify-center dr-cursor-pointer ripple dr-overflow-hidden"
        onClick={(e) => {
          onChange(moment(value).subtract(1, "day"));
        }}
      >
        <ChevronDownRegularIcon className="dr-rotate-90" />
      </div>
      <DatePicker
        className="dr-flex-1 dr-text-center"
        suffixIcon={null}
        value={value as any}
        onChange={(value) => {
          if (!value) return;
          onChange(value);
        }}
        clearIcon={null}
        allowClear={false}
        bordered={false}
        style={{ padding: 0 }}
        inputRender={(props) => {
          const _date = props?.value as string;
          if (!_date) {
            return null;
          }

          const currDateObject =
            getDateObjectFromYYYYMMDDWithTimezoneAdjusted(_date);
          const formattedDateString = dateFormat(currDateObject, "DDD, dd mmm");

          return (
            <div
              className="BodyBold flex items-center justify-center dr-h-36 dr-px-8 dr-w-full dr-cursor-pointer flex-1 dr-text-darwin-touch-primary-primary"
              {...props}
            >
              {formattedDateString}
            </div>
          );
        }}
        disabledDate={(date) => {
          const formattedDate = date.toDate().getTime() / 1000;
          const today = dayjs().startOf("day").toDate().getTime() / 1000;

          const thirtyDays = 90 * 24 * 60 * 60;

          if (today - formattedDate >= thirtyDays) {
            return true;
          }

          return false;
        }}
      />
      <div
        className="dr-w-30 dr-min-w-30 dr-h-full dr-flex dr-items-center dr-justify-center dr-cursor-pointer ripple dr-overflow-hidden"
        onClick={(e) => {
          onChange(moment(value).add(1, "day"));
        }}
      >
        <ChevronDownRegularIcon className="-dr-rotate-90" />
      </div>
      <style>{`
        #date-selector {
          background: ${isToday ? "#E9EFFF" : "transparent"} !important;
          border: 2px solid #E9EFFF !important;
        }
        td.ant-picker-cell-selected > div.ant-picker-cell-inner {
          background : #215FFF !important;
        }
        td.ant-picker-cell-selected > div.ant-picker-cell-inner:before {
          border-color : #215FFF !important;
        }
        div.ant-picker-footer > a.ant-picker-today-btn {
          color: #215FFF !important;
        }
      `}</style>
    </div>
  );
};

export default CustomDatePicker;
